export default {
  applies_to_articles: 'Se aplică la următoarele produse',
};
